import React, { useState } from 'react';
import { cn } from '@/lib/utils';

interface AvatarProps {
    src: string;
    alt?: string;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const sizeClasses = {
    sm: 'zentri-w-8 zentri-h-8',
    md: 'zentri-w-10 zentri-h-10',
    lg: 'zentri-w-12 zentri-h-12',
};

export const Avatar: React.FC<AvatarProps> = ({
    src,
    alt = 'Avatar',
    size = 'md',
    className,
}) => {
    const [imageError, setImageError] = useState(false);

    // Fallback avatar initials or emoji
    const getFallback = () => {
        if (alt?.toLowerCase().includes('bot')) {
            return '🤖';
        }
        return '👤';
    };

    return (
        <div
            className={cn(
                'zentri-flex-shrink-0 zentri-rounded-full zentri-overflow-hidden',
                'zentri-border-2 zentri-border-white zentri-shadow-subtle',
                'zentri-bg-gradient-to-br zentri-from-brand-100 zentri-to-brand-200',
                'zentri-flex zentri-items-center zentri-justify-center zentri-text-xl',
                sizeClasses[size],
                className
            )}
        >
            {imageError ? (
                <span className="zentri-font-semibold">{getFallback()}</span>
            ) : (
                <img
                    src={src}
                    alt={alt}
                    className="zentri-w-full zentri-h-full zentri-object-cover"
                    loading="lazy"
                    onError={() => setImageError(true)}
                />
            )}
        </div>
    );
};
